import eyecaptainIcon from "@/assets/eyecaptain-icon-optimized.webp";
import { cn } from "@/lib/utils";

/**
 * The one loading state for the whole product: the logo mark inside a slowly
 * turning mint arc, and a mono label under it, on the green-black ground.
 * Used for route loading, the splash and embeds.
 */
export function BrandLoader({ label = "Loading", fullScreen = true, className }: { label?: string; fullScreen?: boolean; className?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "relative flex flex-col items-center justify-center bg-background text-foreground",
        fullScreen ? "min-h-screen" : "min-h-[320px]",
        className,
      )}
    >
      <div aria-hidden className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_40%_35%_at_50%_45%,hsl(var(--primary)/0.10),transparent_70%)]" />
      <div className="relative h-20 w-20">
        <svg viewBox="0 0 80 80" className="absolute inset-0 h-full w-full animate-spin" style={{ animationDuration: "1.4s" }} aria-hidden>
          <circle cx="40" cy="40" r="37" fill="none" stroke="hsl(var(--border))" strokeWidth="2" />
          <circle cx="40" cy="40" r="37" fill="none" stroke="hsl(var(--ec-mint))" strokeWidth="2" strokeLinecap="round" strokeDasharray="58 175" />
        </svg>
        <img src={eyecaptainIcon} alt="" width={44} height={44} className="absolute left-1/2 top-1/2 h-11 w-11 -translate-x-1/2 -translate-y-1/2 object-contain" />
      </div>
      <p className="relative mt-5 font-mono text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--ec-muted))]">
        {label}
        <span className="inline-block w-4 text-left after:animate-pulse after:content-['…']" />
      </p>
    </div>
  );
}

export default BrandLoader;
